// extracted by mini-css-extract-plugin
export default {"imageStyles":"styles_imageStyles__wLvm-"};